import request from "@/utils/request";

export default function agentGetCarportByPage(params) {
    return request.get('/device/carport/agentGetCarportByPage', {
        params
    })
}
